var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1771,
    cy: 13.0154,
    r: 12.5,
    fill: "#D9EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8481 14.7435C16.673 13.8519 17.1771 12.6592 17.1771 11.3487C17.1771 8.58732 14.9385 6.34875 12.1771 6.34875C9.4157 6.34875 7.17712 8.58732 7.17712 11.3487C7.17712 14.1102 9.4157 16.3487 12.1771 16.3487C13.1456 16.3487 14.0498 16.0734 14.8157 15.5967L18.7058 19.4868L19.6486 18.544L15.8481 14.7435ZM15.8438 11.3487C15.8438 13.3738 14.2022 15.0154 12.1771 15.0154C10.1521 15.0154 8.51046 13.3738 8.51046 11.3487C8.51046 9.3237 10.1521 7.68208 12.1771 7.68208C14.2022 7.68208 15.8438 9.3237 15.8438 11.3487Z",
    fill: "#0B71ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.fc7304f38f4d508bfc6432c845e8b7d7.svg";
export { ForwardRef as ReactComponent };